import { Address } from "./Address";

export class OwnerDetails {
    ownerType: string;

     //Added 
     address: Address;
     personFirst: string;
     personMiddle: string;
     personLast: string;
     personPrefix: string;
     personSuffix : string;
     companyName : string;
     trustName : string;
     trustDate : string;
     ownerTypeDisplay: string;
     emailAddress: string;
     phoneNumber: string;

    constructor() {
        this.ownerType = '';
        this.address = new Address();
        this.personFirst= '';
        this.personMiddle= '';
        this.personLast= '';
        this.personPrefix= '';
        this.personSuffix = '';
        this.companyName = '';
        this.trustName= '';
        this.trustDate= '';
        this.ownerTypeDisplay = '';
        this.emailAddress = '';
        this.phoneNumber = '';
    }
}
